import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'photoGed'
})
export class PhotoGedPipeMock implements PipeTransform {

	transform(value: any, args?: any): any {
		return value;
	}

}
